import React from 'react';
import '../styles/fonts.css';
import ContactForm from './ContactForm';
const gradientTextStyle = {
    background: 'linear-gradient(to right, #ff0000 5%, #ff8c00 10%, #ffd700 65%, #ff69b4 85%)',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    backgroundClip: 'text'
};

function AboutUs() {
    const handleSubmit = (e) => {
        e.preventDefault();
        const formData = new FormData(e.target);
        const data = {
            name: formData.get('name'),
            phone: formData.get('phone'),
            email: formData.get('email'),
            message: formData.get('message')
        };

        // Log the form data (replace with your actual submission logic)
        console.log('Form submitted:', data);

        // Clear the form
        e.target.reset();

        // You can add your API call here
        // Example:
        // fetch('/api/contact', {
        //     method: 'POST',
        //     headers: {
        //         'Content-Type': 'application/json',
        //     },
        //     body: JSON.stringify(data),
        // });
    };

    return (
        <div className="overflow-hidden position-relative" style={{
            backgroundSize: '100% auto',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            backgroundAttachment: 'fixed',
            width: '100%',
            maxWidth: '1728px',
            margin: '0 auto'
        }}>
            {/* Add gradient circles */}
            <div className="gradient-circle gradient-circle-left"></div>
            <div className="gradient-circle gradient-circle-right"></div>

            {/* Services Section */}
            <div className="container-fluid px-4 px-md-5 py-5">
                <div className="row align-items-center justify-content-center">
                    <div className="col-12 col-lg-5 order-lg-1 order-2">
                        <h1 className="display-4 text-start mb-2"
                            style={{
                                fontFamily: 'Avenir, sans-serif',
                                fontSize: window.innerWidth < 768 ? '32px' : '40px',
                                fontWeight: 'bold'
                            }}>
                            <span style={{ color: '#BC2025' }}>Technology</span> That<br />
                            <span style={{ color: '#BC2025' }}>Empowers</span> Your<br />
                            <span style={{ color: '#BC2025' }}>Business</span> of Tomorrow
                        </h1>
                        <div className="row d-flex justify-content-between mb-4">
                            <div className="col-1">
                                <div style={{
                                    width: '100%',
                                    height: '5px',
                                    backgroundColor: '#BC2025',
                                    marginBottom: '5px',
                                    marginTop: '10px'
                                }}></div>
                            </div>
                            <div className="col-11 text-start">
                                <span style={{ 
                                    fontFamily: 'Avenir, sans-serif', 
                                    fontSize: window.innerWidth < 768 ? '18px' : '24px' 
                                }}>
                                    Cresco is here to helps you build, integrate, and drive your digital transformation. We provide custom software, infrastructure, and cybersecurity solutions tailored for modern businesses. We optimize your IT ecosystem and ensure scalability and security for the future.
                                </span>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-lg-5 order-lg-2 order-1 mb-4 mb-lg-0">
                        <img src="/textlogored.png" alt="About Us" className="img-fluid" />
                    </div>
                </div>


                <div className="row justify-content-center">
                    <div className="col-12 col-lg-10">
                        <div className="row row-cols-1 row-cols-md-2 row-cols-lg-2 g-4 w-100">
                            {[
                                {
                                    image: "/aboutUs/deliver.png",
                                    subtitle: "Vision & Mission",
                                    title: "Deliver",
                                    description: "Develop and implement customized software, infrastructure, and cybersecurity solutions tailored to industry needs."
                                },
                                {
                                    image: "/aboutUs/drive.png",
                                    subtitle: "Digital Transformation",
                                    title: "Drive",
                                    description: "Be the force that drive your businesses vision for a more streamline operations, higher security, and improve efficiency with the latest practice and technology"
                                },
                                {
                                    image: "/aboutUs/ensure.png",
                                    subtitle: "Reliability & Security",
                                    title: "Ensure",
                                    description: "Provide robust and future-proof IT infrastructure that supports growth and resilience."
                                },
                                {
                                    image: "/aboutUs/innovate.png",
                                    subtitle: "With Purpose",
                                    title: "Innovate",
                                    description: "Stay ahead of industry trends, leveraging emerging technologies to create smarter, faster, and more efficient IT ecosystems."
                                }
                            ].map((item, index) => (
                                <div className="col" key={index}>
                                    <div className="card border-0" style={{ backgroundColor: 'transparent' }}>
                                        <div className="card-body text-start d-flex flex-column">
                                            <div className="row flex-column flex-md-row h-100">
                                                <div className="col-12 col-md-6 mb-3 mb-md-0">
                                                    <div style={{ position: 'relative', paddingBottom: '100%' }}>
                                                        <img
                                                            src={item.image}
                                                            alt="Server Hardware"
                                                            className="img-fluid"
                                                            style={{
                                                                position: 'absolute',
                                                                top: 0,
                                                                left: 0,
                                                                width: '100%',
                                                                height: '100%',
                                                                objectFit: 'cover',
                                                                borderRadius: '10px'
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-12 col-md-6 d-flex flex-column">
                                                    <span className="text-start" style={{ fontFamily: 'Avenir, sans-serif', fontSize: '16px', fontWeight: 'bold' }}>
                                                        {item.subtitle}
                                                    </span>
                                                    <h5 className="card-title mb-3" style={{
                                                        color: '#BC2025',
                                                        fontFamily: 'Godber, sans-serif',
                                                        fontSize: '28px'
                                                    }}>{item.title}</h5>
                                                    <p className='text-muted mb-0' style={{ fontFamily: 'Avenir, sans-serif', fontSize: '16px' }}>
                                                        {item.description}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>

            <div className="container-fluid px-4 px-md-5 py-5">
                <div className="row justify-content-center">
                    <div className="col-12 col-lg-10">
                        <h1 className="display-4 text-start mb-0"
                            style={{
                                ...gradientTextStyle,
                                fontFamily: 'Godber, sans-serif',
                                fontSize: window.innerWidth < 768 ? '32px' : '40px'
                            }}>
                            Experts
                        </h1>
                        <h2 className="text-start" style={{ 
                            fontFamily: 'Avenir, sans-serif', 
                            fontSize: window.innerWidth < 768 ? '28px' : '36px', 
                            fontWeight: 'bold' 
                        }}>
                            Why Choose Us?
                        </h2>

                        <p className='text-start' style={{ 
                            fontFamily: 'Avenir, sans-serif', 
                            fontSize: window.innerWidth < 768 ? '18px' : '24px' 
                        }}>
                            At Cresco, we are committed to delivering scalable, secure, and future-proof IT solutions that empower businesses across industries. No matter the sector, our expertise ensures that your technology investments align with your business goals and industry requirements.
                        </p>

                        <p className='text-start' style={{ 
                            fontFamily: 'Avenir, sans-serif', 
                            fontSize: window.innerWidth < 768 ? '18px' : '24px' 
                        }}>
                            We build technology-driven strategies that empower businesses to thrive in the digital era. Whether you need custom software, IT infrastructure, cybersecurity, or digital transformation, we are your trusted technology partner
                        </p>
                    </div>
                </div>
            </div>

            {/* Services Section */}
            <div className="container-fluid px-4 px-md-5 py-5">
                <div className="row justify-content-center">
                    <div className="col-12 col-lg-10">
                        <h1 className="display-4 text-start mb-0"
                            style={{
                                ...gradientTextStyle,
                                fontFamily: 'Godber, sans-serif',
                                fontSize: '40px'
                            }}>
                            Our Services
                        </h1>
                        <div className="row d-flex align-items-center justify-content-between mb-4">
                            <div className="col-auto">
                                <h2 className="mb-2 text-start" style={{ fontFamily: 'Avenir, sans-serif', fontSize: '36px', fontWeight: 'bold' }}>
                                    Tech-Driven, Future Ready
                                </h2>
                            </div>
                            <div className="col-auto">
                                <button className="btn rounded-0"
                                    onClick={() => window.location.href = '/services'}
                                    style={{
                                        width: '200px',
                                        height: '56px',
                                        backgroundColor: '#BC2025',
                                        color: 'white',
                                        fontSize: '16px',
                                        fontWeight: 'bold',
                                        fontFamily: 'Avenir, sans-serif'
                                    }}>
                                    <span className="me-3">Our Services</span>
                                    <img src="/arrow.png" alt="arrow" style={{ width: '20px', height: '20px' }} />
                                </button>
                            </div>
                        </div>

                        <div className="row row-cols-1 row-cols-md-2 row-cols-lg-4 g-2">
                            <div className="col">
                                <div className="card border-0" style={{ backgroundColor: 'transparent' }}>
                                    <div className="card-body text-start">
                                        <h5 className="card-title mb-0" style={{
                                            color: '#BC2025',
                                            fontFamily: 'Godber, sans-serif',
                                            fontSize: '28px'
                                        }}>Digital Transformation</h5>
                                        <span className="card-text font-weight-bold d-flex align-items-center mb-3" style={{ fontSize: '16px', fontWeight: 'bold' }}>
                                            <i className="bi bi-arrow-right-short" style={{ fontSize: '20px', fontWeight: 'bold' }}></i>
                                            <span>(Server Hardware)</span>
                                        </span>
                                        <img src="/services/digitalTransformation.png" alt="Server Hardware" className="img-fluid mb-3" style={{ maxWidth: '100%', height: 'auto', borderRadius: '10px' }} />
                                        <span className="card-text d-flex align-items-start" style={{
                                            fontSize: '16px',
                                            fontWeight: 'bold',
                                            marginBottom: '2px',
                                            paddingRight: '10px'
                                        }}>
                                            <i className="bi bi-arrow-right-short" style={{ fontSize: '16px', fontWeight: 'bold',}}></i>
                                            <span style={{ color: '#BC2025', fontFamily: 'Avenir, sans-serif' }}>Data Center Solutions</span>
                                        </span>
                                        <span className="card-text d-flex align-items-start" style={{
                                            fontSize: '16px',
                                            fontWeight: 'bold',
                                            marginBottom: '2px',
                                            paddingRight: '10px'
                                        }}>
                                            <i className="bi bi-arrow-right-short" style={{ fontSize: '16px', fontWeight: 'bold' }}></i>
                                            <span style={{ color: '#BC2025', fontFamily: 'Avenir, sans-serif' }}>Cloud Infrastructure Solutions</span>
                                        </span>
                                        <span className="card-text d-flex align-items-start" style={{
                                            fontSize: '16px',
                                            fontWeight: 'bold',
                                            paddingRight: '10px'
                                        }}>
                                            <i className="bi bi-arrow-right-short" style={{ fontSize: '16px', fontWeight: 'bold' }}></i>
                                            <span style={{ color: '#BC2025', fontFamily: 'Avenir, sans-serif' }}>Virtualization & Compute Solutions</span>
                                        </span>
                                    </div>
                                </div>
                            </div>

                            <div className="col">
                                <div className="card border-0" style={{ backgroundColor: 'transparent' }}>
                                    <div className="card-body text-start">
                                        <h5 className="card-title mb-0" style={{
                                            color: '#BC2025',
                                            fontFamily: 'Godber, sans-serif',
                                            fontSize: '28px'
                                        }}>Enterprise Solutions</h5>
                                        <span className="card-text font-weight-bold d-flex align-items-center mb-3" style={{ fontSize: '16px', fontWeight: 'bold' }}>
                                            <i className="bi bi-arrow-right-short" style={{ fontSize: '20px', fontWeight: 'bold' }}></i>
                                            <span>(System Integration)</span>
                                        </span>
                                        <img src="/services/systemIntegration.png" alt="System Integration" className="img-fluid mb-3" style={{ maxWidth: '100%', height: 'auto', borderRadius: '10px' }} />
                                        <span className="card-text d-flex align-items-start" style={{
                                            fontSize: '16px',
                                            fontWeight: 'bold',
                                            marginBottom: '2px',
                                            paddingRight: '10px'
                                        }}>
                                            <i className="bi bi-arrow-right-short" style={{ fontSize: '16px', fontWeight: 'bold' }}></i>
                                            <span style={{ color: '#BC2025', fontFamily: 'Avenir, sans-serif' }}>ERP & CRM Integration</span>
                                        </span>
                                        <span className="card-text d-flex align-items-start" style={{
                                            fontSize: '16px',
                                            fontWeight: 'bold',
                                            marginBottom: '2px',
                                            paddingRight: '10px'
                                        }}>
                                            <i className="bi bi-arrow-right-short" style={{ fontSize: '16px', fontWeight: 'bold' }}></i>
                                            <span style={{ color: '#BC2025', fontFamily: 'Avenir, sans-serif' }}>IT Infrastructure Integration</span>
                                        </span>
                                        <span className="card-text d-flex align-items-start" style={{
                                            fontSize: '16px',
                                            fontWeight: 'bold',
                                            paddingRight: '10px'
                                        }}>
                                            <i className="bi bi-arrow-right-short" style={{ fontSize: '16px', fontWeight: 'bold' }}></i>
                                            <span style={{ color: '#BC2025', fontFamily: 'Avenir, sans-serif' }}>Cybersecurity Integration</span>
                                        </span>
                                    </div>
                                </div>
                            </div>

                            <div className="col">
                                <div className="card border-0" style={{ backgroundColor: 'transparent' }}>
                                    <div className="card-body text-start">
                                        <h5 className="card-title mb-0" style={{
                                            color: '#BC2025',
                                            fontFamily: 'Godber, sans-serif',
                                            fontSize: '28px'
                                        }}>Software Development</h5>
                                        <span className="card-text font-weight-bold d-flex align-items-center mb-3" style={{ fontSize: '16px', fontWeight: 'bold' }}>
                                            <i className="bi bi-arrow-right-short" style={{ fontSize: '20px', fontWeight: 'bold' }}></i>
                                            <span>(Custom Applications)</span>
                                        </span>
                                        <img src="/services/customApplications.png" alt="Custom Applications" className="img-fluid mb-3" style={{ maxWidth: '100%', height: 'auto', borderRadius: '10px' }} />
                                        <span className="card-text d-flex align-items-start" style={{
                                            fontSize: '16px',
                                            fontWeight: 'bold',
                                            marginBottom: '2px',
                                            paddingRight: '10px'
                                        }}>
                                            <i className="bi bi-arrow-right-short" style={{ fontSize: '16px', fontWeight: 'bold' }}></i>
                                            <span style={{ color: '#BC2025', fontFamily: 'Avenir, sans-serif' }}>Business Process Automation</span>
                                        </span>
                                        <span className="card-text d-flex align-items-start" style={{
                                            fontSize: '16px',
                                            fontWeight: 'bold',
                                            marginBottom: '2px',
                                            paddingRight: '10px'
                                        }}>
                                            <i className="bi bi-arrow-right-short" style={{ fontSize: '16px', fontWeight: 'bold' }}></i>
                                            <span style={{ color: '#BC2025', fontFamily: 'Avenir, sans-serif' }}>AI & Data Analytics Platforms</span>
                                        </span>
                                        <span className="card-text d-flex align-items-start" style={{
                                            fontSize: '16px',
                                            fontWeight: 'bold',
                                            paddingRight: '10px'
                                        }}>
                                            <i className="bi bi-arrow-right-short" style={{ fontSize: '16px', fontWeight: 'bold' }}></i>
                                            <span style={{ color: '#BC2025', fontFamily: 'Avenir, sans-serif' }}>Mobile & Web Application Development</span>
                                        </span>
                                    </div>
                                </div>
                            </div>

                            <div className="col">
                                <div className="card border-0" style={{ backgroundColor: 'transparent' }}>
                                    <div className="card-body text-start">
                                        <h5 className="card-title mb-0" style={{
                                            color: '#BC2025',
                                            fontFamily: 'Godber, sans-serif',
                                            fontSize: '28px'
                                        }}>Maintained & Support</h5>
                                        <span className="card-text font-weight-bold d-flex align-items-center mb-3" style={{ fontSize: '16px', fontWeight: 'bold' }}>
                                            <i className="bi bi-arrow-right-short" style={{ fontSize: '20px', fontWeight: 'bold' }}></i>
                                            <span>(Managed Services)</span>
                                        </span>
                                        <img src="/services/manageService.png" alt="Managed Services" className="img-fluid mb-3" style={{ maxWidth: '100%', height: 'auto', borderRadius: '10px' }} />
                                        <span className="card-text d-flex align-items-start" style={{
                                            fontSize: '16px',
                                            fontWeight: 'bold',
                                            marginBottom: '2px',
                                            paddingRight: '10px'
                                        }}>
                                            <i className="bi bi-arrow-right-short" style={{ fontSize: '16px', fontWeight: 'bold' }}></i>
                                            <span style={{ color: '#BC2025', fontFamily: 'Avenir, sans-serif' }}>24/7 IT Support & Monitoring</span>
                                        </span>
                                        <span className="card-text d-flex align-items-start" style={{
                                            fontSize: '16px',
                                            fontWeight: 'bold',
                                            marginBottom: '2px',
                                            paddingRight: '10px'
                                        }}>
                                            <i className="bi bi-arrow-right-short" style={{ fontSize: '16px', fontWeight: 'bold' }}></i>
                                            <span style={{ color: '#BC2025', fontFamily: 'Avenir, sans-serif' }}>Backup & Disaster Recovery</span>
                                        </span>
                                        <span className="card-text d-flex align-items-start" style={{
                                            fontSize: '16px',
                                            fontWeight: 'bold',
                                            paddingRight: '10px'
                                        }}>
                                            <i className="bi bi-arrow-right-short" style={{ fontSize: '16px', fontWeight: 'bold' }}></i>
                                            <span style={{ color: '#BC2025', fontFamily: 'Avenir, sans-serif' }}>Software Updates & Patch Management</span>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Contact Us Section */}
            <ContactForm />
        </div>
    );
}

export default AboutUs; 